import { TableSortLabelTypeMap } from '@mui/material/TableSortLabel';
import { ColumnDefinition } from 'shared/components/table/columnDefinition';
import RowItem from 'shared/components/table/types/row-item';
import { NestedKeyof } from 'shared/components/table/utils/nested-keyof-utils';

type TableHeader = {
  allRowsSelected: boolean;
};

export type TableHeaderProps<DataType extends object, Key extends NestedKeyof<DataType>> = {
  data: RowItem<DataType>[];
  columns: ColumnDefinition<DataType, Key>[];
  rowsAreSelectable?: boolean;
  selectedRows?: RowItem<DataType>[];
  onSelectAllRowsChanged?: (checked: boolean) => void;

  orderDirection: TableSortLabelTypeMap['props']['direction'];
  orderBy: string;
  onRequestSort: (property: Key) => void;
  hasOverflowMenu: boolean;
};

const useTableHeader = <DataType extends object, Key extends NestedKeyof<DataType>>({
  data,
  selectedRows,
}: TableHeaderProps<DataType, Key>): TableHeader => {
  return {
    allRowsSelected: selectedRows?.length !== 0 && selectedRows?.length === data.length,
  };
};

export default useTableHeader;
